import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";
const AuthCtx = createContext({ user: null, loading: true, reload: () => {}, signout: async () => {} });

export function AuthProvider({ children }) {
  const [state, setState] = useState({ user: null, loading: true });

  const reload = useCallback(async () => {
    try {
      const { data } = await axios.get(API + "/account/me", { withCredentials: true });
      setState({ user: data, loading: false });
    } catch {
      setState({ user: null, loading: false });
    }
  }, []);

  const signout = useCallback(async () => {
    try { await axios.post(API + "/account/session/signout", {}, { withCredentials: true }); }
    catch { /* fall through */ }
    setState({ user: null, loading: false });
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return <AuthCtx.Provider value={{ ...state, reload, signout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
